import { render, staticRenderFns } from "./VotingCheckboxes.vue?vue&type=template&id=33d7fcf8&"
import script from "./VotingCheckboxes.vue?vue&type=script&lang=js&"
export * from "./VotingCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports